"use client";

import { useEffect, useState } from "react";
import Link from "next/link";

type Seller = {
  id: number;
  name: string;
  logo_url: string | null;
};

type Auction = {
  id: number;
  title: string;
  type: string;
  location: string | null;
  start_at: string | null;
  end_at: string | null;
  main_seller_name?: string;
  main_seller_logo?: string;
  sellers?: Seller[];
};

export default function AgendaPage() {
  const [auctions, setAuctions] = useState<Auction[]>([]);

  useEffect(() => {
    async function carregar() {
      const res = await fetch("https://api.nexbid.pro/auctions");
      const data = await res.json();

      if (Array.isArray(data)) {
        const agora = new Date();

        const filtrados = data
          .filter((a: Auction) => {
            if (!a.end_at) return true;

            const encerramento = new Date(a.end_at);
            encerramento.setHours(encerramento.getHours() + 2);

            return encerramento > agora;
          })
          .sort((a: Auction, b: Auction) => {
            const dataA = a.start_at ? new Date(a.start_at).getTime() : 0;
            const dataB = b.start_at ? new Date(b.start_at).getTime() : 0;
            return dataA - dataB;
          });

        setAuctions(filtrados);
      }
    }

    carregar();
  }, []);

  function traduzTipo(tipo: string) {
    if (tipo === "ONLINE") return "Somente On-line";
    if (tipo === "PRESENCIAL") return "Somente Presencial";
    if (tipo === "HIBRIDO") return "Presencial e On-line";
    return tipo;
  }

  return (
    <div style={{ padding: 40 }}>
      <h1 style={{ marginBottom: 40 }}>Agenda de Leilões</h1>

      <style jsx>{`
        .grid-auctions {
          display: grid;
          gap: 30px;
          grid-template-columns: repeat(1, 1fr);
        }

        @media (min-width: 768px) {
          .grid-auctions {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (min-width: 1200px) {
          .grid-auctions {
            grid-template-columns: repeat(4, 1fr);
          }
        }

        .card {
          border: 1px solid #1f2937;
          padding: 25px;
          border-radius: 12px;
          background: #0f172a;
          color: #fff;
          transition: 0.3s;
          height: 100%;
        }

        .card:hover {
          transform: translateY(-4px);
          border-color: #3b82f6;
        }

        .main-logo {
          height: 60px;
          object-fit: contain;
          margin-bottom: 15px;
        }

        .seller-logos {
          display: flex;
          gap: 8px;
          margin-top: 10px;
          flex-wrap: wrap;
        }

        .seller-logos img {
          height: 30px;
          opacity: 0.7;
        }
      `}</style>

      <div className="grid-auctions">
        {auctions.map((a) => (
          <Link key={a.id} href={`/auction/${a.id}`}>
            <div className="card">
            
             {a.main_seller_logo && (
              <img
                src={a.main_seller_logo}
                alt={a.main_seller_name}
                className="main-logo"
                onError={(e) => {
                  (e.currentTarget as HTMLImageElement).style.display = "none";
                }}
              />
            )}

              <h3 style={{ marginBottom: 10 }}>{a.title}</h3>

              {a.start_at && (
                <p>
                  <strong>Data:</strong>{" "}
                  {new Date(a.start_at).toLocaleString()}
                </p>
              )}

              {a.location && (
                <p>
                  <strong>Local:</strong> {a.location}
                </p>
              )}

              <p>
                <strong>Tipo:</strong> {traduzTipo(a.type)}
              </p>

              {a.sellers && (
                <div className="seller-logos">
                  {a.sellers
                  ?.filter((s) => s.logo_url)
                  .slice(0, 4)
                  .map((s) => (
                    <img
                      key={`${a.id}-${s.id}`}
                      src={s.logo_url!}
                      alt={s.name}
                      onError={(e) => {
                        (e.currentTarget as HTMLImageElement).style.display = "none";
                      }}
                    />
                  ))}
                </div>
              )}

            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}